interface IdleCallback {
  miliseconds: number;
  fn: () => any;
}

export class UserActivityService {
  private idleStart?: number;
  private idleTime = 0;
  private idleCallbacks: Array<IdleCallback> = [];
  private idleCallbacksPointer = 0;
  private pageIsActive = true;
  private pageIsActiveCallbacks: Array<() => any> = [];
  private pageIsInactiveCallbacks: Array<() => any> = [];
  private userInteractedWithPage = false;
  private userInteractionCallbacks: Array<() => any> = [];

  constructor() {
    this.resetCallbacks = this.resetCallbacks.bind(this);
    this.pageBecameActive = this.pageBecameActive.bind(this);
    this.pageBecameInactive = this.pageBecameInactive.bind(this);
    this.detectInteraction = this.detectInteraction.bind(this);
    setInterval(() => this.fireCallbacks(), 10000);
    window.addEventListener("mousemove", this.resetCallbacks);
    window.addEventListener("keypress", this.resetCallbacks);
    window.addEventListener("focus", this.pageBecameActive);
    window.addEventListener("blur", this.pageBecameInactive);
    window.addEventListener("keypress", this.detectInteraction);
    window.addEventListener("click", this.detectInteraction);
  }

  private fireCallbacks() {
    if (!this.idleStart) {
      this.idleStart = Date.now();
    }
    this.idleTime = Date.now() - this.idleStart;
    while (this.idleCallbacksPointer < this.idleCallbacks.length) {
      const idleCallback = this.idleCallbacks[this.idleCallbacksPointer];
      if (idleCallback!.miliseconds <= this.idleTime) {
        this.idleCallbacksPointer++;
        setTimeout(idleCallback!.fn);
      } else {
        break;
      }
    }
  }

  private resetCallbacks() {
    this.idleStart = undefined;
    this.idleCallbacksPointer = 0;
  }

  private pageBecameActive() {
    this.pageIsActive = true;
    this.pageIsActiveCallbacks.forEach((fn) => setTimeout(fn));
  }

  private pageBecameInactive() {
    this.pageIsActive = false;
    this.pageIsInactiveCallbacks.forEach((fn) => setTimeout(fn));
  }

  private detectInteraction() {
    this.userInteractedWithPage = true;
    this.userInteractionCallbacks.forEach((fn) => setTimeout(fn));
    window.removeEventListener("keypress", this.detectInteraction);
    window.removeEventListener("click", this.detectInteraction);
  }

  getIdleTime() {
    return this.idleTime;
  }

  onIdle(miliseconds: number, fn: () => any) {
    this.idleCallbacks = this.idleCallbacks
      .filter((ic) => ic.miliseconds < miliseconds)
      .concat([{ miliseconds, fn }])
      .concat(this.idleCallbacks.filter((ic) => ic.miliseconds >= miliseconds));
  }

  isPageActive() {
    return this.pageIsActive;
  }

  /**
   * Whether the page lost user attention (lost focus or passed acceptable idle time).
   */
  isPageInactive() {
    return !this.pageIsActive || this.idleTime > 30000;
  }

  onPageIsActive(fn: () => any) {
    this.pageIsActiveCallbacks.push(fn);
  }

  onPageIsInactive(fn: () => any) {
    this.pageIsInactiveCallbacks.push(fn);
  }

  didUserInteractWithPage() {
    return this.userInteractedWithPage;
  }

  onFirstUserInteraction(fn: () => any) {
    this.userInteractionCallbacks.push(fn);
  }
}
